import React, { useState } from 'react';
import {
  TabbedView,
  Tab,
  TabList,
  TabPanel,
} from 'components/shared/TabbedView';
import { routes } from 'constants/config';
import { useFeatureFlags, usePermissions } from 'components/shared/hooks';
import { Icon } from 'components/ui';
import ContentTagTable from './ContentTagTable';
import NewContentTagTable from './NewContentTagTable';
import SkillTagTable from './SkillTagTable';

const TagsIndex = () => {
  const hasSkillsEnabled = useFeatureFlags([
    'readiness-enable-skills-2-0',
    'skills',
  ]);
  const { isPermitted: isSkillsAdmin } = usePermissions({
    type: 'skill',
    action: 'skills_admin',
  });
  const shouldShowSkillsTab = hasSkillsEnabled && isSkillsAdmin;

  const TAG_TABS = {
    CONTENT: 'Content',
    SKILL: 'Skill',
  };
  const TABS_ARRAY = [TAG_TABS.CONTENT, TAG_TABS.SKILL];
  const [tab, setTab] = useState(TAG_TABS.CONTENT);

  return (
    <div
      className="panel row tags"
      data-back-title={t('tags.table.all')}
      data-back-level="0"
    >
      <header className="panel-header-underlined ">
        <h1 className="panel-title">{t('tags.table.all')}</h1>
      </header>
      <div className="d-f jc-fe fd-rr ai-c">
        {shouldShowSkillsTab && tab === TAG_TABS.CONTENT && (
          <div
            type="button"
            className="Button Button--linked SettingsContent-subSection-addButton"
          >
            <Icon name="add" className="mr-4 c-brand-gray" />
            <a href={routes.TAGS_NEW}>{t('skills.add_button')}</a>
          </div>
        )}
      </div>
      {shouldShowSkillsTab ? (
        <TabbedView
          selectedIndex={TABS_ARRAY.indexOf(tab)}
          onSelect={index => setTab(TABS_ARRAY[index])}
        >
          <TabList
            className="d-f ai-c mb-16"
            tabClassName="border-navy-dark pl-24 pr-24"
          >
            <Tab>{t('tags.table.tabs.content')}</Tab>
            <Tab>{t('tags.table.tabs.skill')}</Tab>
          </TabList>
          <TabPanel>
            <NewContentTagTable />
          </TabPanel>
          <TabPanel>
            <SkillTagTable />
          </TabPanel>
        </TabbedView>
      ) : (
        <ContentTagTable />
      )}
    </div>
  );
};

export default props => <TagsIndex {...props} />;
